export default __webpack_public_path__ + "static/media/Group853.5999333a.svg";